import React from 'react'
import MaterialBox from '../../../../../../components/MaterialBox'
import MaterialTypography from '../../../../../../components/MaterialTypography'

const CountCard = ({ name, count, color }) => {
    return (
        <MaterialBox sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
            padding: 1,
            borderRadius: '8px',
            background: "linear-gradient(45deg, rgba(202, 229, 237, 1) 57%, rgba(148, 187, 233, 1) 100%)",
        }}>
            <MaterialTypography varinat='h6' fontWeight='bold' sx={{ color: '#788E9B' }}>{name}</MaterialTypography>
            <MaterialTypography variant='h4' fontWeight='bold' color='#fff' sx={{ color: '#fff' }}>{count}</MaterialTypography>
        </MaterialBox>
    )
}

export default CountCard
